// removed by extract-text-webpack-plugin
module.exports = {"projectsWrapper":"src-components-Projects----Projects-module---projectsWrapper---2yQ9-","title":"src-components-Projects----Projects-module---title---3yFPK","project":"src-components-Projects----Projects-module---project---3lMBH","projectImg":"src-components-Projects----Projects-module---projectImg---3N4Cu","projectLink":"src-components-Projects----Projects-module---projectLink---11dmK","projectInfo":"src-components-Projects----Projects-module---projectInfo---2HxfL","projectTitle":"src-components-Projects----Projects-module---projectTitle---yA2pn"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Projects/Projects.module.css
// module id = 302
// module chunks = 35783957827783